import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useResetPassword = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post(`Authentication/resetPassword`, formData);
  });
  return mutation;
};
export default useResetPassword;
